export default "__VITE_ASSET__DrRldads__"